import React from 'react'
import { useSelector } from 'react-redux'
import { Container, BadgeOfficial, BadgeVerified, BadgeMember } from '../../../components'
import { useViewport } from '../../../utils'
import { ProfileHeaderImage } from './profile-header-image'
import { ProfileHeaderMetas } from './profile-header-metas'

const ProfileHeader = ({profile}) => {
  const { isMobile } = useViewport()
  const { isOfficial, isVerified } = useSelector(state => state.account)
  const { language } = useSelector(state => state.system)

  const {
    image,
    name,
    // city,
    email,
    institution,
    isMember,
    organization,
    occupation = {
      en: undefined,
      id: undefined
    }
  } = profile

  const occupationRendered = occupation[language.name]

  return (
    <Container color="#f5f5f5" className="py-8 lg:py-20">
      <div className="flex flex-wrap -mx-4 items-start mb-4 lg:mb-0">
        <div className="w-1/4 lg:w-2/12 px-4">
          <ProfileHeaderImage image={image} />
        </div>
        <div className="w-3/4 lg:w-10/12 px-4">
          <h1 className="font-primary font-bold text-2xl lg:text-3xl mb-2 md:mb-5">
            { name }
          </h1>

          <div className="md:mb-5">
            {
              isMember ? <>
                {
                  organization ? (
                    <div className="flex items-center">
                      <BadgeOfficial />
                      <p className="ml-2 text-sm text-gray-444">Member of {organization}</p>
                    </div>
                  ) : (
                    <div className="flex items-center">
                      <BadgeMember />
                      <p className="ml-2 text-sm text-gray-444">Member</p>
                    </div>
                  )
                }
              </> : institution ? (
                <div className="flex items-center">
                  <BadgeOfficial />
                  <p className="ml-2 text-sm text-gray-444">Member of {institution}</p>
                </div>
              ) : isOfficial ? (
                <div className="flex items-center">
                  <BadgeOfficial />
                  <p className="ml-2 text-sm text-gray-444">Member of Peacegen Indonesia</p>
                </div>
              ) : isVerified ? (
                <div className="flex items-center">
                  <BadgeVerified />
                  <p className="ml-2 text-sm text-gray-444">Verified User</p>
                </div>
              ) : (
                <div className="flex items-center">
                  <BadgeMember />
                  <p className="ml-2 text-sm text-gray-444">User</p>
                </div>
              )
            }
          </div>
          {
            !isMobile &&
            <ProfileHeaderMetas
              isMobile={isMobile}
              organization={organization}
              email={email}
              occupation={occupationRendered}
            />
          }
        </div>
      </div>
      {
        isMobile &&
        <ProfileHeaderMetas
          isMobile={isMobile}
          organization={organization}
          email={email}
          occupation={occupationRendered}
        />
      }
    </Container>
  )
}

export { ProfileHeader }
